export var CallBackType;
(function (CallBackType) {
    CallBackType["FILTER_CHANGE"] = "filter_change_cb";
    CallBackType["INLINE_FILTER_CHANGE"] = "inline_filter_change_cb";
    CallBackType["REFRESH_DATA"] = "refresh_data_cb";
    CallBackType["LOAD_MORE"] = "load_more_cb";
    CallBackType["LOAD_MODAL"] = "load_modal_cb";
    CallBackType["LOAD_SUBPAGE"] = "load_sub_page";
})(CallBackType || (CallBackType = {}));
export var SubPageType;
(function (SubPageType) {
    SubPageType["OPEN_MODAL"] = "OPEN_MODAL";
})(SubPageType || (SubPageType = {}));
